import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadContent () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.pagination.getParams(),
    })

    api.get('contents', { params })
      .then(result => {
        this.contents = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  askDelete (contentId) {
    this.showDeleteDialog = true
    this.deletingId = contentId
  },

  cancelDelete () {
    this.showDeleteDialog = false
    this.deletingId = null
  },

  confirmDelete () {
    if (!this.deletingId) {
      return
    }

    const api = getApiClient(this.$store)

    api.delete(this.deletingId)
      .then(result => {
        if (result.status === 204) {
          this.$store.commit('app/raiseSuccess', 'Conteúdo excluído')
          this.loadContent()
        }
      })
      .catch(() => {
        this.$store.commit('app/raiseError', 'Erro ao excluir conteúdo')
        this.loadContent()
      })
      .finally(() => {
        this.cancelDelete()
      })
  },
}
